export default {
  data() {
    return {
      paysafe: null,
    }
  },

  methods: {
    async showPaysafeModale(montant, holderName = "") {

      // Validation des paramètres obligatoires
      if (montant <= 0) {
        console.error("ErreurPaysafeMixin: Le montant doit être supérieur à 0.")
        return;
      }

      // Chargement du script de la librairie Paysafe checkout
      if (!this.paysafe) {
        if (!window.paysafe) {
          await this.$loadScript(process.env.VUE_APP_PAYSAFE_SDK)
        }
        this.paysafe = window.paysafe
      }
      // Affichage de la modale
      this.paysafe.checkout.setup(
        process.env.VUE_APP_PAYSAFE_APIKEY,
        this.getOptionsPaysafe(montant, holderName),
        this.onSubmitPaysafe,
        this.onClosePaysafe
      )

    },
    // Genere l'objet de paramètrage pour affichage de la modale Paysafe
    getOptionsPaysafe(montant, holderName = "") {
      var baseOptions = {
        amount: parseInt(montant * 100),
        holderName: holderName,
        currency: "CAD",
        companyName: this.$t("paysafe.companyName"),
        locale: this.$t("paysafe.locale"),
        buttonLabel: this.$t("paysafe.buttonLabel"),
        environment: process.env.VUE_APP_ENVIRONEMENT_PAYSAFE,
        imageUrl: process.env.VUE_APP_LOGO_PAYSAFE,
        displayPaymentMethods: ['Cards']
      }
      return baseOptions
    },
    // Evenement déclenché lorsque paysafe nous renvoit une réponse après avoir entré les informations de CB dans la modale
    onSubmitPaysafe(instance, error, result) {
      if (instance) {
        instance.close()
      }
      if (error) {
        console.error(error)
        return;
      }
      if (this.onSuccessPaysafe) {
        this.onSuccessPaysafe(result.token)
      }
    },
    onClosePaysafe(stage) {
      if (stage === 'BeforePayment') {
        if (this.onCloseBeforePayment) {
          this.onCloseBeforePayment()
        }
        // No payment have been made
      } else if (stage === 'DuringPayment') {
        // Token have been issued, but the checkout overlay was closed from the user before instance flow control method was invoked
      } else if (stage === 'AfterPayment') {
        // Closed either via instance.close method or by the user from the success screen
      }
    },
  }
}
